import apiClient from "utils/ApiClient";
import { RECIPES } from "configurations/Urls";

const RecipeService = {
  async getChemicals() {
    const response = await apiClient.get(`${RECIPES}/chemicals`);
    return response.data;
  },
  async getRecipes(params, signal) {
    const response = await apiClient.get(`${RECIPES}?${params}`, { signal });
    return response.data;
  },

  async getRecipeTypes() {
    const response = await apiClient.get(`${RECIPES}/types`);
    return response.data;
  },
  async addRecipe(recipe) {
    const response = await apiClient.post(`${RECIPES}`, recipe);
    return response.data;
  },
  async updateRecipe(recipe, recipeId) {
    const response = await apiClient.put(`${RECIPES}/${recipeId}`, recipe);
    return response.data;
  },
  async deleteRecipe(recipeId) {
    const response = await apiClient.delete(`${RECIPES}/${recipeId}`);
    return response.data;
  },
  async shareRecipes(payload) {
    const response = await apiClient.post(`${RECIPES}/share`, payload);
    return response.data;
  },
  async updateShare(shareId, recipeId, payload) {
    const response = await apiClient.put(
      `${RECIPES}/${recipeId}/share/${shareId}`,
      payload
    );
    return response.data;
  },
  async getSharedRecipes(recipeId) {
    const response = await apiClient.get(`${RECIPES}/${recipeId}/share`);
    return response.data;
  },
};

export default RecipeService;
